import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FAKE_LOAD_MS } from '@common/constants/business.constants';
import { DEFAULT_TITLE, SECTION_TITLES } from '@common/constants/section-titles.constants';
import { ISectionConst } from '@common/interfaces/titles.interface';
import { RouteUtils } from '@common/utils/routes/routes';
import { Utils } from '@common/utils/utils';
import { LoadingService } from '@services/loading/loading.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss'],
})
export class BaseLayoutComponent implements OnInit, OnDestroy {

  @Input() showFooter: boolean;
  @Input() isRouted: boolean;

  public currentPage: string;
  public sectionConst: ISectionConst;
  private routerSubscription: Subscription;

  constructor(
    private router: Router,
    private utils: Utils,
    private routeUtils: RouteUtils,
    private loading: LoadingService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.showFooter = true;
    this.sectionConst = DEFAULT_TITLE;
    this.isRouted = true;
  }

  ngOnInit() {
    this.setRouterPipe();
  }

  public setRouterPipe() {
    this.routerSubscription = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      this.currentPage = this.routeUtils.handleCurrentRouteSection(event.urlAfterRedirects);
      this.sectionConst = SECTION_TITLES[this.currentPage];
      if (this.sectionConst?.falseLoading) { this.fakeLoad(); }
      if (isPlatformBrowser(this.platformId)) { this.utils.scrollToId('baseContentSection'); }
    });
  }

  public ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  private fakeLoad() {
    this.loading.showLoading();
    setTimeout(() => this.loading.hideLoading(), FAKE_LOAD_MS);
  }

}
